import {
  getBanners,
  getGrades,
  getHomeGrades,
  getKids,
  getPackages,
  getSubjects,
} from '../../apis';
import {
  SET_BANNERS,
  SET_GRADES,
  SET_HOME_GRADES,
  SET_KIDS,
  SET_PACKAGES,
  SET_SUBJECTS,
} from '../reducers/general';

export function getAndSetAllKids() {
  return async (dispatch, getState) => {
    const data = await getKids();
    dispatch(setKids(data));
    return data;
  };
}

export function getAndSetAllSubjects() {
  return async (dispatch, getState) => {
    const data = await getSubjects();
    dispatch(setSubjects(data));
    return data;
  };
}

export function getAndSetAllGrades() {
  return async (dispatch, getState) => {
    const data = await getGrades();
    dispatch(setGrades(data));
    return data;
  };
}

export function getAndSetHomeGrades() {
  return async (dispatch, getState) => {
    const data = await getHomeGrades();
    dispatch(setHomeGrades(data));
    return data;
  };
}

export function getAndSetAllPackages() {
  return async (dispatch, getState) => {
    const data = await getPackages();
    dispatch(setPackages(data));
    return data;
  };
}

export function getAndSetBanners() {
  return async (dispatch, getState) => {
    const data = await getBanners();
    dispatch(setBanners(data));
    return data;
  };
}

function setKids(data) {
  return {
    type: SET_KIDS,
    payload: {data},
  };
}

function setGrades(data) {
  return {
    type: SET_GRADES,
    payload: {data},
  };
}

function setHomeGrades(data) {
  return {
    type: SET_HOME_GRADES,
    payload: {data},
  };
}

function setSubjects(data) {
  return {
    type: SET_SUBJECTS,
    payload: {data},
  };
}

function setPackages(data) {
  return {
    type: SET_PACKAGES,
    payload: {data},
  };
}

function setBanners(data) {
  return {
    type: SET_BANNERS,
    payload: {data},
  };
}
